import * as moment from 'moment-timezone';

import {
  getEventIds,
  getEventOthersFilter,
  getPeriodsState,
  getUniqueChar,
} from '../reducers/analyticsApp';
import { toFilter } from '../converters/filterConverter';
import { setErrorMessage } from './application';

const emptyErrorHandler = () => ({});

const dispatchError = (dispatch, error) => {
  dispatch(setErrorMessage(error.text || error.message || 'Something went wrong'));
};

export const buildQueries = (state, detailsAssembler, unitId) => {
  return detailsAssembler(state, unitId);
};

export const getPeriodUniqueChar = (id, periods) =>
  periods
    .map((period, index) => ({
      period,
      uniqueChar: `${index + 1}`,
    }))
    .filter(({ period }) => !!period.from.length)
    .map(({ uniqueChar }) => uniqueChar);

export const createCharArray = (state) => {
  const ids = getEventIds(state);
  const getSplitWithOthersChar = (id) =>
    !getEventOthersFilter(state, id) ? [] : `${getUniqueChar(state, id)}.Others`;

  return ids.flatMap((id) =>
    [getUniqueChar(state, id)]
      .concat(
        getPeriodUniqueChar(id, getPeriodsState(state, id).periods).map(
          (c) => `${getUniqueChar(state, id)}${c}`
        )
      )
      .concat(getSplitWithOthersChar(id))
  );
};

export const transformStep = (step, stepIndex) => ({
  enabled: step.enabled,
  eventName: step.event,
  count: step.count,
  countOperator: step.countOperator,
  closingRange: moment.duration((step.closingRange || {}).value).toISOString(),
  filter: toFilter(step.filter),
  optional: !!step.optional && stepIndex !== 0,
  type: step.type === 'LOCAL_NEGATIVE' ? 'NOT_DONE' : 'DONE',
});

export const asyncAction =
  (type, apiFn, errorHandler = emptyErrorHandler) =>
  (dispatch, getState) => {
    dispatch({
      type: `${type}`,
    });
    return apiFn(dispatch, getState).then(
      (response) => {
        dispatch({
          type: `${type}_SUCCESS`,
          ...response,
        });

        return response;
      },
      (error) => {
        errorHandler(dispatch, getState, error.text || error.message || 'Something went wrong');
        dispatch({
          type: `${type}_FAILURE`,
        });

        dispatchError(dispatch, error);
      }
    );
  };
